import React, { useMemo, memo } from 'react';
import PropTypes from 'prop-types';

const FraudScore = ({ value, displayStatus }) => {
  const className = useMemo(() => {
    if (value < 25) {
      return 'bg-green-lowRisk text-green-lowRisk';
    } else if (25 <= value && value <= 69) {
      return 'bg-amber text-amber';
    } else if (70 <= value && value <= 99) {
      return 'bg-javelin-danger text-javelin-danger';
    } else {
      return 'bg-javelin-gray-light text-javelin-gray-light';
    }
  }, [value]);

  const status = useMemo(() => {
    if (value < 25) {
      return 'Low Risk';
    } else if (25 <= value && value <= 69) {
      return 'Medium Risk';
    } else if (70 <= value && value <= 99) {
      return 'High Risk';
    } else {
      return 'Blocked';
    }
  }, [value]);

  return (
    <div className="text-sm text-javelin-gray-dark flex flex-row items-center">
      <span
        className={`p-0.5 bg-opacity-10 flex items-center justify-center rounded-full mr-1 text-xs h-5 w-5 box-content ${className}`}
        data-testid="fraud-score"
      >
        {value}
      </span>
      {displayStatus && <span className="inline-block">{status}</span>}
    </div>
  );
};

FraudScore.propTypes = {
  displayStatus: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
FraudScore.defaultProps = {
  displayStatus: true,
  value: 0,
};

export default memo(FraudScore);
